import { cn } from '@repo/ui/lib/utils'
import { ComponentPropsWithoutRef, FunctionComponent } from 'react'

interface Props extends ComponentPropsWithoutRef<'span'> {
  className?: string
  checked?: boolean
}

const FakeRadio: FunctionComponent<Props> = ({ className, checked = false, ...rest }) => {
  return (
    <div
      className={cn(
        'border-(--color-foreground)/20 ring-offset-(--bg) flex size-3.5 items-center justify-center rounded-full border hover:border-current group-hover:border-current',
        checked && 'bg-(--color-foreground) hover:bg-(--color-foreground)/20 border-current',
        className,
      )}
      {...rest}
    />
  )
}

export default FakeRadio
